import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const Skeleton = ({ className = "", ...rest })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: `bg-gray-300 animate-pulse ${className}`,
        ...rest,
        "aria-hidden": "true"
    });
};
